import styles from "../../styles/addInvoice.module.css";

export default function FilialDetailsHeader() {
  return (
    <div className={styles["filial-details-header"]}>
      <h1>
        <i className={`fa-solid fa-house ${styles["icon-filial-details"]}`}></i>
        Información de la Filial
      </h1>
    </div>
  );
}
